import {CdTemporaryMeasure} from '../../../interfaces/care/cd-execution-proof/cd-temporary-measure';
import {LightCustomer} from '../../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../../customers/light-customer-factory';
import {LightUser} from '../../../interfaces/core/light-user';
import {LightUserFactory} from '../../core/light-user-factory';
import {UserService} from '../../../services/core/user.service';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from '../cd-care-plan/cd-frequency-factory';
import { v4 as uuidv4 } from 'uuid';
import {DateTime} from 'luxon';
import {DateHelper} from '../../../helpers/date-helper';

export class CdTemporaryMeasureFactory {

  /**
   *
   * @param cdTemporaryMeasure
   */
  public static fromObject(cdTemporaryMeasure: any): CdTemporaryMeasure {
    return new class implements CdTemporaryMeasure {
      customer: LightCustomer =
        cdTemporaryMeasure.customer ? LightCustomerFactory.fromObject(cdTemporaryMeasure.customer) : null;
      customerId: number = cdTemporaryMeasure.customer_id;
      name: string = cdTemporaryMeasure.name;
      comment: string = cdTemporaryMeasure.comment;
      type: 'temporary' | 'one_time' = cdTemporaryMeasure.type;
      validFrom: string = DateHelper.toIsoDate(cdTemporaryMeasure.valid_from);
      validTo: string = DateHelper.toIsoDate(cdTemporaryMeasure.valid_to);
      readAt: string = cdTemporaryMeasure.read_at;
      readByUserId: number = cdTemporaryMeasure.read_by_user_id;
      readByUser: LightUser =
        cdTemporaryMeasure.read_by_user ? LightUserFactory.fromObject(cdTemporaryMeasure.read_by_user) : null;
      userId: number = cdTemporaryMeasure.user_id;
      user: LightUser = cdTemporaryMeasure.user ? LightUserFactory.fromObject(cdTemporaryMeasure.user) : null;
      cdFrequencies: CdFrequency[] =
        cdTemporaryMeasure.c_frequencies ? CdFrequencyFactory.fromArray(cdTemporaryMeasure.c_frequencies) : [];

      // ------------------------------------------------------------------------------------------------
      id: number = cdTemporaryMeasure.id;
      uuid: string = cdTemporaryMeasure.uuid;
      modified: string = cdTemporaryMeasure.modified;
      created: string = cdTemporaryMeasure.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param cdTemporaryMeasures
   */
  public static fromArray(cdTemporaryMeasures: any[]): CdTemporaryMeasure[] {
    return cdTemporaryMeasures.map(_cdTemporaryMeasure => CdTemporaryMeasureFactory.fromObject(_cdTemporaryMeasure));
  }

  /**
   *
   * @param cdTemporaryMeasure
   */
  public static toRemote(cdTemporaryMeasure: CdTemporaryMeasure): any {
    return {
      id: cdTemporaryMeasure.id,
      uuid: cdTemporaryMeasure.uuid,
      modified: cdTemporaryMeasure.modified,
      created: cdTemporaryMeasure.created,
      customer_id: cdTemporaryMeasure.customerId,
      name: cdTemporaryMeasure.name,
      comment: cdTemporaryMeasure.comment,
      type: cdTemporaryMeasure.type,
      valid_from: cdTemporaryMeasure.validFrom,
      valid_to: cdTemporaryMeasure.validTo,
      read_at: cdTemporaryMeasure.readAt,
      read_by_user_id: cdTemporaryMeasure.readByUserId,
      user_id: cdTemporaryMeasure.userId,
      c_frequencies: CdFrequencyFactory.toArray(cdTemporaryMeasure.cdFrequencies), //CdFrequencyFactory.toRemote()
    };
  }

  /**
   *
   */
  public static new(): CdTemporaryMeasure {
    return new class implements CdTemporaryMeasure {
      customer: LightCustomer = null;
      customerId: number = null;
      name: string = null;
      comment: string = null;
      type: 'temporary' | 'one_time' = 'temporary';
      validFrom: string = null;
      validTo: string = null;
      readAt: string = null;
      readByUserId: number = null;
      readByUser: LightUser = null;
      userId: number = UserService.getUser().id;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());
      cdFrequencies: CdFrequency[] = [];
      // ------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = uuidv4();
      modified: string = DateTime.local().toISO();
      created: string = DateTime.local().toISO();
      deleted: 0 | 1 = 0;
    };
  }

}
